<template>
  <DeepLinkContent
    title="deepLink.linkNotFound"
    text="Please make sure the link is correct and try again"
  />

  <NewInput
    v-model="link"
    :class="$style.input"
    :error="$t(error)"
  />
  <NewButton
    :class="$style.button"
    :isLoading="isLoading"
    @click="emit('join')"
  >
    {{ $t('deepLink.joinLesson') }}
  </NewButton>
</template>

<script setup>
import DeepLinkContent from '@/deepLinks/components/DeepLinkContent.vue';
import NewInput from '@/shared/components/UI/Input/NewInput.vue';
import NewButton from '@/shared/components/UI/Button/NewButton.vue';

const { isLoading, error } = defineProps({
  isVisible: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    required: true,
  },
  error: {
    type: [String, null],
    required: true,
  },
});

const link = defineModel('link', { type: String, required: true });
const emit = defineEmits(['join']);

</script>

<style lang="scss" module>
.input {
  margin-top: 24px;
}

.button {
  max-width: fit-content;
  min-width: 120px;
  margin: 24px auto;
}

</style>
